import { render, staticRenderFns } from "./SetColumns.vue?vue&type=template&id=18fb6aee&scoped=true&"
import script from "./SetColumns.vue?vue&type=script&lang=js&"
export * from "./SetColumns.vue?vue&type=script&lang=js&"
import style0 from "./SetColumns.vue?vue&type=style&index=0&id=18fb6aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb6aee",
  null
  
)

export default component.exports